// libraries
import clsx from 'clsx'
import type { ReactNode } from 'react'

// css
import './index.scss'

// prop types
interface LoadingProps {
    className?: string
    text?: string
    spinner?: ReactNode
}

export default function Loading({
    className,
    text,
    spinner
}: LoadingProps) {

    if (!spinner) {
        return (
            <div className={className}>
                {text}
            </div>
        )
    }

    return (
        <div className={clsx(
            'loading-state',
            className
        )}>

            <div className='loading-state__icon'>
                {spinner}
            </div>

            {text && (
                <p className='loading-state__text body'>
                    {text}
                </p>
            )}

        </div>
    )
}
